export enum PaymentPlanTypeEnums {
  FREE_TRIAL = 'FREE_TRIAL',
  CANCELLED = 'CANCELLED',
  PAID = 'PAID',
}
